import React from "react";
import styled from "styled-components";
import {PortfolioMessage} from "./PortfolioMessage";
import {TruncatedName} from "./TruncatedName";

export const PortfolioColumn = styled.div`
    display: flex;
    text-transform: none;
    font-size: 11px;
`;

export const PortfolioCell = styled(PortfolioColumn)`
    flex-direction: column;
    align-items: stretch;
`;

const CompanyName = styled(TruncatedName)`
    font-size: 10px;
`;

export const PortfolioName = ({portfolioName, portfolioCompanyName, portfolioMessage}) => {
    return <div>
        <TruncatedName>{portfolioName}</TruncatedName>
        <CompanyName>{portfolioCompanyName}</CompanyName>
        <PortfolioMessage portfolioName={portfolioName}
                          portfolioCompanyName={portfolioCompanyName}
                          portfolioMessage={portfolioMessage}/>
    </div>
};


